import React, { Component } from 'react'
// import { PropTypes } from 'prop-types'
// import { updateComponent } from '../../state/actions/componentsActions'
import Styles from './styles'
import { css, withStyles } from '../../styles/withStyles'
import MobileDetect from 'mobile-detect'
import {isMobileOnly,isTablet} from 'react-device-detect'
class Iframe extends Component {
  constructor(props) {
    super(props)
  }

   renderOtpMessage=(component)=>{
  
  return (!!component.otpMessage?<p {...css(this.props.styles.otpMessage)}>Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare</p>:"")
  }
  render() {
    const { component } = this.props
    const md = new MobileDetect(window.navigator.userAgent)
    //if (!!md.mobile() && md.tablet()) {
      if(isMobileOnly && !isTablet){
    return (

      <iframe
        name={this.props.name}
        src={component.value}
        // width="700px"
         //height="500px"
         //max-width="51rem"
        {...css(this.props.styles.iframeMobile)} 
        hidden={this.props.component.status.indexOf('hidden') > -1}
      />
    )
    }
    else{
    return (
      <div>
      <div {...css(this.props.styles.outeroverlay)}>
      </div>
      
      <div {...css(isTablet && this.props.styles.overlayTablet,!isTablet && this.props.styles.overlay)} >
      {this.renderOtpMessage(component)}
      {/* <p {...css(this.props.styles.otpMessage)}>Scegli un codice PIN di firma di 5 cifre e inserisci il codice OTP di firma che hai appena ricevuto sul tuo numero di cellulare</p> */}
        <iframe
          {...css(isTablet && this.props.styles.iframeTablet,!isTablet && this.props.styles.iframe)} 
          name={this.props.name}
          src={component.value}
          hidden={this.props.component.status.indexOf('hidden') > -1}
        />
      
      </div>
      </div>
    )
  }
  }
}
export default withStyles(Styles)(Iframe) 



// WEBPACK FOOTER //
// ./components/iframe/index.js